export default __webpack_public_path__ + "static/syncLock_1x.png";